import React from 'react';
import Input from '../components/Input';
import Text from '../components/Text';

function Avatar(props) {

    const classes = props.classes || null;
    const src = `  ${props.src}` || 'https://via.placeholder.com/128x128?text=AvatarWordIn';
    const type = props.type || 'w-avatar-sm';
    const nom = props.nom || 'nom';
    const mail = props.mail || 'mail';
    const worder = props.worder || null;
    const text = props.text || 'text';
    //   alert(src)
    return (
        <>
            {
                type === 'w-avatar-sm' && <div className={classes}  >
                    <img src={src} alt={text} />
                    <Text text={nom} classes="w-text-black-m-lte" />
                </div>
            }
            {
                type === 'w-avatar-lg' && <div className='w-avatar-lg bg-blue-semi-lte'>
                    
                        <div className="w-avatar-sm"  >

                            <img src={src} alt={text} />
                            <Text text={nom} classes="w-text-black-m-lte" />
                        </div>
                    
                        <div className="w-avatar-lg-right"  >

                             
                            <Text text={worder} classes="w-text-blue-xl" />
                            <Text text={text} classes="w-text-blue-m" />
                        </div>
                     
                </div>
            }

            {
                type === 'w-avatar-info' && <div className={classes}  >
                    <img src={src} alt={text} />
                    <Text text={nom} classes="w-text-nom" />
                    <Text text={mail} classes="w-text-default w-text-email" />
                    <Text text={worder} classes="w-text-default w-text-bold w-text-worder" />
                </div>
            }
            {
                type === 'w-avatar-xl' && <div className={classes}  >
                    <img src={src} alt={text} />
                    <Text text={nom} classes="w-text-default w-text-blue-l" />
                    <Text text={text} classes="w-text-default w-text-gray-l" />
                </div>
            }
        </>
    );
}

export default Avatar;